import axios from "infra/http";
import { useQuery } from "react-query";
import { EncomendaDto } from "../typings/index";

function useDetalheEncomenda(id: string | undefined) {
  return useQuery(
    `/v1/encomenda/${id}`,
    async () => {
      const { data } = await axios.get<EncomendaDto>(`/v1/encomenda/${id}`);

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useDetalheEncomenda;
